import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import EventInfo from './eventInfo';
import { getVenueType } from '~/selectors/event';
const EventInfoContainer = (props) => {
    return _jsx(EventInfo, { ...props });
};
const mapStateToProps = (state) => ({
    type: getVenueType(state),
});
export default connect(mapStateToProps)(EventInfoContainer);
